module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-33.2b99d075.jpg";